<template>
  <div class="playlist-container" v-if="playlist">
    <ol class="vjs-playlist-item-list">
      <li
        v-for="(video, index) in playlist"
        :key="index"
        :class="{
          'video-playlist-card': true,
          'vjs-selected': video.selected,
          'vjs-up-next': isNextVideo(index)
        }"
        :id="'playlistItem-' + index"
        tabindex="0"
        @click="PlaylistItemClick(index)"
      >

        <picture class="vjs-playlist-thumbnail">
          <source :srcset="video.thumbnail[0].srcset" />
          <img :alt="'video-playlist-thumbnail-' + index" :src="video.thumbnail[1].src" />
          <svg v-if="video.selected" class="center-svg-play" width="40" height="40" viewBox="0 0 458 459" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
            <circle cx="228.5" cy="229.5" r="194.5" fill="var(--vm-color-two-06)" />
            <path
              d="M229 0.700026C198.951 0.689514 169.194 6.60042 141.43 18.095C113.666 29.5895 88.4389 46.4424 67.1907 67.6905C45.9426 88.9387 29.0897 114.166 17.5952 141.93C6.10061 169.694 0.189697 199.451 0.200209 229.5C0.189697 259.549 6.10061 289.306 17.5952 317.07C29.0897 344.834 45.9426 370.061 67.1907 391.31C88.4389 412.558 113.666 429.411 141.43 440.905C169.194 452.4 198.951 458.311 229 458.3C259.05 458.311 288.807 452.4 316.571 440.905C344.335 429.411 369.562 412.558 390.81 391.31C412.058 370.061 428.911 344.834 440.405 317.07C451.9 289.306 457.811 259.549 457.8 229.5C457.811 199.451 451.9 169.694 440.405 141.93C428.911 114.166 412.058 88.9387 390.81 67.6905C369.562 46.4424 344.335 29.5895 316.571 18.095C288.807 6.60042 259.05 0.689514 229 0.700026ZM229 422.14C190.9 422.14 153.655 410.842 121.975 389.674C90.2957 368.507 65.6045 338.421 51.0241 303.22C36.4436 268.02 32.6287 229.286 40.0617 191.918C47.4948 154.549 65.842 120.224 92.7832 93.283C119.724 66.3418 154.05 47.9946 191.418 40.5616C228.787 33.1285 267.52 36.9434 302.72 51.5239C337.921 66.1043 368.007 90.7955 389.175 122.475C410.342 154.154 421.64 191.399 421.64 229.5C421.598 280.578 401.288 329.552 365.17 365.67C329.053 401.788 280.079 422.098 229 422.14Z"
              fill="white" />
            <path
              d="M177.122 315.997C178.33 316.667 179.666 317 181 317C182.474 317 183.945 316.593 185.24 315.784L313.24 235.785C315.579 234.323 317 231.759 317 229.001C317 226.242 315.579 223.679 313.24 222.217L185.24 142.216C182.773 140.674 179.665 140.593 177.122 142.003C174.578 143.413 173 146.092 173 149V309C173 311.908 174.578 314.587 177.122 315.997Z"
              fill="white" />
          </svg>


          <div class="vjs-playlist-title-container">
            <span class="vjs-playlist-now-playing-text" :title="$t('player.Title')"> {{ $t('player.in_progress') }}</span>
            <span class="vjs-up-next-text" :title="$t('player.next')">{{ $t('player.next') }}</span>
            <div class="vjs-playlist-name" :title="video.name">
              {{ video.name }}
            </div>
          </div>
        </picture>
        <time class="vjs-playlist-duration" datetime="PT0H0M20S">{{
          formatTime(+video.duration)
        }}</time>
      </li>
    </ol>
  </div>
</template>

<script >
require("videojs-playlist");
import "videojs-playlist-ui/dist/videojs-playlist-ui.vertical.css";
import "videojs-playlist-ui/dist/videojs-playlist-ui.css";
import "videojs-playlist-ui";
import "videojs-playlist";
import { defineComponent } from "vue";

export default defineComponent({
  name: "PlayListVideos",
  props: ["playlist", "PlaylistItemClick","loopOption","currentIndex"],
  emits: ["playlis-item-click"],
  methods: {
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = Math.floor(seconds % 60);

      const formattedHours =
        hours > 0 ? (hours < 10 ? "0" + hours : hours) + ":" : "";
      const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      const formattedSeconds =
        remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;

      return formattedHours + formattedMinutes + ":" + formattedSeconds;
    },
    isNextVideo(index) {
      const lastIndex = this.playlist.length - 1;
      if (lastIndex === 0) {
        return false;
      }

      if (this.loopOption && this.playlist[lastIndex].selected) {
        return index === 0 || this.playlist[index - 1]?.selected;
      }

      return this.playlist[index - 1]?.selected && !this.playlist[index].selected;
    }
  ,

  },
});
</script>

<style scoped>
.video-playlist-card {
  margin-bottom: 5px;
  position: relative;
  cursor: pointer;

  overflow: hidden;
}

.video-playlist-card.vjs-selected {
  background-color: var(--vm-color-one-06);

}

.video-playlist-card .vjs-playlist-thumbnail {
  display: block;
  width: 100%;
}

.video-playlist-card img {
  display: block;
  height: 100%;
  width: 100%;
}

.video-playlist-card .vjs-playlist-now-playing-text {
  display: none;
  color: var(--vm-color-three-04) !important;
}

.video-playlist-card .vjs-playlist-title-container {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 0.5rem 0.8rem;
 text-shadow: 1px 1px 2px var(--vm-color-one-06), -1px 1px 2px var(--vm-color-one-06), 1px -1px 2px var(--vm-color-one-06), -1px -1px 2px var(--vm-color-one-06);
  font-size: 1vw;
  color: var(--vm-color-three);
}

.video-playlist-card .vjs-playlist-title-container .vjs-up-next-text {
  display: none;
}

.video-playlist-card .vjs-playlist-duration {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  padding: 2px 5px 3px;
  margin-left: 2px;
  background-color: var(--vm-color-one-08);
  color: var(--vm-color-three);
  border-radius: 0.25em;
}

.vjs-playlist-item-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
</style>
